module.exports = __webpack_public_path__ + "6c5ffd121f25e7178c6fd7ba60f8f3cf.pdf";